import { combineReducers } from 'redux'
import { persistReducer } from 'redux-persist'
import sessionStorageAdapter from './sessionStorage'
// slices

import allGuaranteesReducer from './slices/all-guarantees'
import notificationsReducer from './slices/notifications'
import legalEntitiesReducer from './slices/legalEntities'
import termsReducer from './slices/terms'
import userReducer from './slices/user'
import pdfReducer from './slices/pdf'
import contractPdfReducer from './slices/contractPdf'
import legalsReducer from './slices/legals'

import createGuaranteeReducer from './slices/create-guarantee-request'
import setGuaranteeRequestPayloadReducer from './slices/create-payload'
import contractHistoryReducer from './slices/contract-history'
import sponsoredEntityReducer from './slices/sponsored-private-entity'
import purposeTypesReducer from './slices/purposeTypes'
import socketConnectReducer from './slices/socket-auth-status'
import networkReducer from './slices/socket-auth-status'
import getErrorReducer from './slices/createError'
import adminCreateActionsReducer from './slices/admin-create-actions'
import adminUsersReducer from './slices/admin-users'
import adminRolesReducer from './slices/admin-roles'
import adminTeamsReducer from './slices/admin-org-details'
import adminLeReducer from './slices/admin-le'
import socketHealthReducer from './slices/socket-health'
import amendmentNotificationReducer from './slices/amendmentNotification'
import workflowErrorReducer from './slices/workflowError'

// ----------------------------------------------------------------------

const rootPersistConfig = {
  key: 'root',
  storage: sessionStorageAdapter,
  keyPrefix: 'redux-session-'
}

const gxPersistConfig = {
  key: 'guarantee',
  storage: sessionStorageAdapter,
  keyPrefix: 'redux-session-'
}

const gxCreateActionsConfig = {
  key: 'admin',
  storage: sessionStorageAdapter,
  keyPrefix: 'redux-session-'
}

const gxAdminRoles = {
  key: 'admin-roles',
  storage: sessionStorageAdapter,
  keyPrefix: 'redux-session-'
}

const gxAdminOrgUnits = {
  key: 'admin-orgs',
  storage: sessionStorageAdapter,
  keyPrefix: 'redux-session-'
}

const userPersistConfig = {
  key: 'user',
  storage: sessionStorageAdapter,
  keyPrefix: 'redux-session-'
}

const createGxPersistConfig = {
  key: 'createGx',
  storage: sessionStorageAdapter,
  keyPrefix: 'redux-session-'
}


const rootReducer = combineReducers({
  createGuarantee: createGuaranteeReducer,
  socketAuthStatus: socketConnectReducer,
  createGuaranteePayload: setGuaranteeRequestPayloadReducer,
  allGuarantees: allGuaranteesReducer,
  notifications: notificationsReducer,
  contractHistory: contractHistoryReducer,
  legalEntities: legalEntitiesReducer,
  termsReducer: termsReducer,
  purposeTypes: purposeTypesReducer,
  network: networkReducer,
  createError: getErrorReducer,
  sponsoredEntity: sponsoredEntityReducer,
  userReducer: userReducer,
  pdfReducer: pdfReducer,
  contractPdfReducer: contractPdfReducer,
  legals: legalsReducer,
  adminCreateActions: adminCreateActionsReducer,
  adminUsers: adminUsersReducer,
  adminRoles: adminRolesReducer,
  adminOrgUnits: adminTeamsReducer,
  adminLeEntities: adminLeReducer,
  socketHealth: socketHealthReducer,
  amendmentNotification: amendmentNotificationReducer,
  workflowError: workflowErrorReducer
})

export { rootPersistConfig, rootReducer }
